import React from 'react';
import { motion } from 'framer-motion';

const BentoCard = ({ children, className = '', hoverable = true, delay = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
      whileHover={hoverable ? { y: -4, transition: { duration: 0.2 } } : {}}
      className={`bg-[var(--bg-card)] border border-[var(--border-light)] rounded-2xl p-6 transition-all duration-300 ${hoverable ? 'hover:shadow-xl hover:border-[var(--accent-primary)]' : ''} ${className}`}
    >
      {children}
    </motion.div>
  );
};

export default BentoCard;